// src/data/sizes.js

export const sizeGroups = {
  /* ==================================================================================
     🧵 UNSTITCHED FABRIC (CRITICAL FOR LOCAL MARKET)
     ================================================================================== */
  'Unstitched Suit Config': [
    '1 Piece (Shirt Front Only)',
    '1 Piece (Shirt Only)',
    '1 Piece (Trouser Only)',
    '1 Piece (Dupatta Only)',
    '1 Piece (Shawl Only)',
    '2 Piece (Shirt & Trouser)',
    '2 Piece (Shirt & Dupatta)',
    '2 Piece (Co-Ord Set)',
    '2.5 Piece (Shirt, Dupatta & Trouser Patch)',
    '2.5 Piece (Shirt, Trouser & Dupatta Patch)',
    '3 Piece (Shirt, Trouser & Dupatta)',
    '3 Piece (Shirt, Trouser & Shawl)',
    '4 Piece (Shirt, Trouser, Dupatta & Inner/Slip)',
    '4 Piece (Fully Embroidered Signature Series)',
    'Loose Fabric (Cut Piece)',
    'Thaan / Bundle (Wholesale 20+ Suits)'
  ],

  'Unstitched Length (Gaz/Yards)': [
    '0.5 Gaz', '0.75 Gaz', '1 Gaz', '1.25 Gaz', '1.5 Gaz', '1.75 Gaz', '2 Gaz', 
    '2.25 Gaz', '2.5 Gaz (Kameez Standard)', '2.75 Gaz', '3 Gaz (Big Shirt)', 
    '3.25 Gaz', '3.5 Gaz', '3.75 Gaz', '4 Gaz (Small Suit)', '4.25 Gaz', 
    '4.5 Gaz', '5 Gaz (Bara Suit)', '5.5 Gaz', '6 Gaz', '6.5 Gaz', '7 Gaz', 
    '8 Gaz', '10 Gaz', '12 Gaz', '15 Gaz', '20 Gaz', '100 Gaz (Thaan)'
  ],

  'Unstitched Length (Meters)': [
    '0.5 M', '0.75 M', '1.0 M', '1.25 M', '1.5 M', '1.75 M', 
    '2.0 M', '2.25 M', '2.5 M (Std Shirt)', '2.75 M', '3.0 M', '3.25 M', 
    '3.5 M', '3.75 M', '4.0 M (Std Suit)', '4.25 M', '4.5 M', '4.75 M', 
    '5.0 M', '5.5 M', '6.0 M', '7.0 M', '8.0 M', '10.0 M', '25 M (Roll)'
  ],

  'Fabric Width (Arz)': [
    '35-36 Inches (Small Arz / Chota Bar)', 
    '39-41 Inches (Normal Arz)', 
    '42-44 Inches (Medium Arz)', 
    '48-50 Inches (Wide Arz)', 
    '52-54 Inches (Large Arz / Bara Bar)', 
    '56-60 Inches (Extra Large Arz)', 
    '90-110 Inches (King Width / Bedding / Curtains)'
  ],

  'Fabric Weight (GSM)': [
    '60 GSM (Very Light Lawn)', '70 GSM', '80 GSM (Lawn Standard)', '90 GSM', 
    '100 GSM', '120 GSM (Cotton)', '140 GSM', '160 GSM (Khaddar)', 
    '180 GSM', '200 GSM (Wool/Linen)', '220 GSM', '250 GSM', '300 GSM (Denim/Coat)'
  ],

  /* ==================================================================================
     👗 WOMEN'S READY-TO-WEAR (STITCHED FASHION)
     ================================================================================== */
  'Women Alpha Sizes': [
    '5XS', '4XS', 'XXXS', 'XXS', 'XS', 'S', 'M', 'L', 'XL', 'XXL', 
    '3XL', '4XL', '5XL', '6XL', '7XL', '8XL', 'Free Size', 'One Size'
  ],

  'Women Kurti Chest (Inches)': [
    '14"', '15"', '16" (XS)', '17" (XS)', 
    '18" (Small)', '19" (Small)', 
    '20" (Medium)', '21" (Medium)', 
    '22" (Large)', '23" (Large)', 
    '24" (XL)', '25" (XL)', 
    '26" (XXL)', '27" (XXL)', 
    '28" (3XL)', '29" (3XL)', '30" (4XL)', 
    '32" (5XL)', '34" (6XL)', '36"', '38"', '40"'
  ],

  'Women Kurti Length (Inches)': [
    '26 (Crop)', '28', '30', '32', '34', '35', '36 (Standard)', '37', 
    '38', '39', '40 (Long)', '41', '42', '43', '44', '45', '46 (Maxi)', 
    '47', '48', '50', '52', '54', '56 (Abaya Style)', '58', '60'
  ],

  'Women Hip Size (Inches)': [
    '34"', '36"', '38"', '40"', '42"', '44"', '46"', '48"', '50"', '52"', '54"'
  ],

  'Women Trousers/Bottoms Waist': [
    '22', '24', '26', '28', '30', '32', '34', '36', '38', '40', '42', '44', '46', '48', '50'
  ],

  'Abaya Sizes (Length)': [
    '48', '50', '51', '52', '53', '54', '55', '56', '57', '58', '59', 
    '60', '61', '62', '63', '64', 'Custom Order'
  ],
  
  'Hijab/Scarf Size': [
    'Square (40x40)', 'Rectangular (28x72)', 'Rectangular (30x80)', 'Maxi Shawl'
  ],

  /* ==================================================================================
     👙 WOMEN'S LINGERIE
     ================================================================================== */
  'Bra Band Size': [
    '28', '30', '32', '34', '36', '38', '40', '42', '44', '46', '48', '50', '52', '54'
  ],
  'Bra Cup Size': [
    'AA', 'A', 'B', 'C', 'D', 'DD', 'E', 'F', 'FF', 'G', 'GG', 'H', 'HH', 'J', 'K'
  ],
  'Panty Size (Hip Measure)': [
    'XS (34")', 'S (36")', 'M (38")', 'L (40")', 'XL (42")', 
    'XXL (44")', '3XL (46")', '4XL (48")', '5XL', '6XL'
  ],

  /* ==================================================================================
     👔 MEN'S FASHION
     ================================================================================== */
  'Men Alpha Sizes': [
    'XXS', 'XS', 'S', 'M', 'L', 'XL', 'XXL', '3XL', '4XL', '5XL', '6XL', '7XL'
  ],

  'Men Collar Size (Neck)': [
    '13"', '13.5"', '14"', '14.5"', '15"', '15.5"', '16"', '16.5"', 
    '17"', '17.5"', '18"', '18.5"', '19"', '19.5"', '20"', '21"'
  ],

  'Men Waist (Jeans/Trousers)': [
    '26', '27', '28', '29', '30', '31', '32', '33', '34', '35', 
    '36', '37', '38', '39', '40', '41', '42', '43', '44', '45', 
    '46', '48', '50', '52', '54', '56', '58', '60'
  ],

  'Men Inseam Length': [
    '26', '27', '28', '29', '30', '31', '32 (Regular)', '33', '34 (Long)', '35', '36', '38'
  ],

  'Kameez Shalwar Length': [
    '34', '36', '38', '40', '42', '44', '46', '48', '50', '52', '54', '56', '58', '60'
  ],

  'Men Vest Sizes': [
    '75cm', '80cm (XS)', '85cm (S)', '90cm (M)', '95cm (L)', '100cm (XL)', 
    '105cm (XXL)', '110cm (3XL)', '115cm (4XL)', '120cm (5XL)'
  ],

  /* ==================================================================================
     👶 KIDS, BABY, TODDLER & TEEN
     ================================================================================== */
  'Baby Age Groups': [
    'Preemie', 'Newborn (NB)', '0-1 Month', '0-3 Months', '3-6 Months', 
    '6-9 Months', '9-12 Months', '12-18 Months', '18-24 Months', '24-36 Months'
  ],

  'Kids Age Groups': [
    '2Y', '2-3Y', '3-4Y', '4-5Y', '5-6Y', '6-7Y', '7-8Y', '8-9Y', 
    '9-10Y', '10-11Y', '11-12Y', '12-13Y', '13-14Y', '14-15Y', '15-16Y'
  ],

  'Kids Height (CM)': [
    '50cm', '56cm', '62cm', '68cm', '74cm', '80cm', '86cm', '92cm', '98cm', 
    '104cm', '110cm', '116cm', '122cm', '128cm', '134cm', '140cm', '152cm', '164cm'
  ],

  /* ==================================================================================
     👟 FOOTWEAR (GLOBAL & DESI)
     ================================================================================== */
  'Men Shoe Sizes (UK/PK)': [
    '3', '3.5', '4', '4.5', '5', '5.5', '6', '6.5', '7', '7.5', '8', '8.5', 
    '9', '9.5', '10', '10.5', '11', '11.5', '12', '12.5', '13', '14', '15'
  ],

  'Desi Footwear Numbers': [
    'No. 6', 'No. 7', 'No. 8', 'No. 9', 'No. 10', 'No. 11', 'No. 12', 'No. 13'
  ],

  'Women Shoe Sizes (UK/PK)': [
    '1', '1.5', '2', '2.5', '3', '3.5', '4', '4.5', '5', '5.5', '6', '6.5', 
    '7', '7.5', '8', '8.5', '9', '9.5', '10', '11', '12'
  ],

  'Kids Shoe Sizes (UK)': [
    '0 (Baby)', '0.5', '1', '1.5', '2', '2.5', '3', '3.5', '4', '4.5', '5', '5.5', 
    '6', '6.5', '7', '7.5', '8', '8.5', '9', '9.5', '10', '10.5', '11', '11.5', 
    '12', '12.5', '13', '13.5', '1 (Junior)', '2 (Junior)', '3 (Junior)', '4 (Junior)', '5 (Junior)'
  ],

  /* ==================================================================================
     💍 JEWELRY (GOLD & ARTIFICIAL)
     ================================================================================== */
  'Gold Weight (PK)': [
    '1 Ratti', '2 Ratti', '4 Ratti', '1 Masha', '2 Masha', '4 Masha', '6 Masha (Half Tola)', 
    '1 Tola', '1.25 Tola', '1.5 Tola', '2 Tola', '2.5 Tola', '3 Tola', '4 Tola', '5 Tola', '10 Tola'
  ],

  'Ring Sizes (US Standard)': [
    '3', '3.5', '4', '4.5', '5', '5.5', '6', '6.5', '7', '7.5', '8', '8.5', 
    '9', '9.5', '10', '10.5', '11', '11.5', '12', '13', '14', '15'
  ],

  'Bangle Sizes': [
    '1.12 (Newborn)', '1.14', '2.0', '2.2 (Sawa Do)', '2.4 (Dhai - Standard)', 
    '2.6 (Sawa Do - Large)', '2.8 (Dhai - XL)', '2.10', '2.12', '2.14', '3.0'
  ],

  'Necklace / Chain Length': [
    '12" (Collar)', '14" (Choker)', '16" (Bib)', '18" (Princess)', '20" (Matinee)', 
    '22"', '24" (Opera)', '26"', '28"', '30" (Rope)', '32"', '36"', '40"'
  ],

  /* ==================================================================================
     📱 MOBILE, TABLETS, COMPUTING & ELECTRONICS
     ================================================================================== */
  'Internal Storage': [
    '4 GB', '8 GB', '16 GB', '32 GB', '64 GB', '128 GB', '256 GB', '512 GB', 
    '1 TB', '2 TB', '4 TB', '8 TB', '10 TB', '12 TB', '16 TB'
  ],

  'RAM Memory': [
    '1 GB', '2 GB', '3 GB', '4 GB', '6 GB', '8 GB', '10 GB', '12 GB', '16 GB', '18 GB', '24 GB', '32 GB', '64 GB'
  ],

  'Screen Size (Mobile)': [
    '4.0"', '4.5"', '4.7"', '5.0"', '5.5"', '5.8"', '6.0"', '6.1"', '6.2"', 
    '6.3"', '6.4"', '6.5"', '6.6"', '6.7"', '6.8"', '6.9"', '7.2"', '7.6"'
  ],

  'Laptop Screen Size': [
    '10.1"', '11.6"', '12.0"', '12.5"', '13.3"', '13.5"', '14.0"', '14.5"', 
    '15.0"', '15.6"', '16.0"', '17.0"', '17.3"', '18.4"'
  ],

  'Processor Cores': [
    'Dual Core', 'Quad Core', 'Hexa Core', 'Octa Core', 'Deca Core', '12 Core', '16 Core'
  ],

  /* ==================================================================================
     📺 TV, AUDIO & HOME ENTERTAINMENT
     ================================================================================== */
  'TV Screen Sizes': [
    '19"', '22"', '24"', '28"', '32"', '39"', '40"', '42"', '43"', '48"', 
    '49"', '50"', '55"', '58"', '60"', '65"', '70"', '75"', '80"', '82"', 
    '85"', '86"', '90"', '98"', '100"', '110"'
  ],

  'Speaker Output (Watts)': [
    '3W', '5W', '10W', '20W', '30W', '40W', '50W', '60W', '80W', '100W', 
    '120W', '200W', '300W', '500W', '600W', '800W', '1000W', '1200W', '2000W'
  ],

  /* ==================================================================================
     ❄️ LARGE APPLIANCES (AC, FRIDGE, WASHING MACHINE)
     ================================================================================== */
  'AC Capacity (Tons)': [
    '0.75 Ton', '1.0 Ton', '1.5 Ton', '2.0 Ton', '2.5 Ton', '3.0 Ton', '4.0 Ton (Floor)'
  ],

  'Refrigerator Capacity (Cu Ft)': [
    '3 Cu Ft', '4 Cu Ft', '5 Cu Ft', '6 Cu Ft', '7 Cu Ft', '8 Cu Ft', '9 Cu Ft', 
    '10 Cu Ft', '11 Cu Ft', '12 Cu Ft', '13 Cu Ft', '14 Cu Ft', '15 Cu Ft', 
    '16 Cu Ft', '17 Cu Ft', '18 Cu Ft', '19 Cu Ft', '20 Cu Ft', '22 Cu Ft', 
    '24 Cu Ft', '26 Cu Ft', '28 Cu Ft'
  ],

  'Washing Machine Capacity': [
    '4 kg', '5 kg', '6 kg', '7 kg', '8 kg', '9 kg', '10 kg', '11 kg', '12 kg', 
    '13 kg', '14 kg', '15 kg', '16 kg', '17 kg', '18 kg', '20 kg', '25 kg'
  ],

  'Geyser Capacity': [
    '6 Gallons', '10 Gallons', '15 Gallons', '20 Gallons', '25 Gallons', 
    '30 Gallons', '35 Gallons', '40 Gallons', '50 Gallons', '55 Gallons'
  ],

  /* ==================================================================================
     🛏️ HOME, BEDDING, FURNITURE & DECOR
     ================================================================================== */
  'Bed Sheet Sizes': [
    'Single (60" x 90")', 'Twin (66" x 96")', 'Double (90" x 96")', 
    'Queen (90" x 100")', 'King (100" x 108")', 'Super King (108" x 108")', 
    'California King', 'Emperor'
  ],

  'Mattress Sizes': [
    'Single (36x78)', 'Twin (39x78)', 'Single Wide (42x78)', 'Double (54x78)', 
    'Queen (60x78)', 'King (72x78)', 'Super King (84x78)'
  ],

  'Mattress Thickness': [
    '4 Inches', '5 Inches', '6 Inches', '8 Inches', '10 Inches', '12 Inches', '14 Inches'
  ],

  'Curtain Dimensions (Width x Length)': [
    '46x54', '46x72', '46x90', '52x63', '52x84', '52x95', '66x54', '66x72', 
    '66x90', '90x72', '90x90', '90x108', 'Custom Size'
  ],

  'Rug / Carpet Sizes (Feet & Marla)': [
    '2x3', '2x4', '3x5', '4x6', '5x7', '5x8', '6x9', '7x10', '8x10', '8x11', 
    '9x12', '9x13', '10x14', '12x15', '12x18', '0.5 Marla', '1 Marla', '2 Marla'
  ],

  'Water Tank Capacity': [
    '100 Gallons', '150 Gallons', '200 Gallons', '300 Gallons', '400 Gallons', 
    '500 Gallons', '750 Gallons', '1000 Gallons', '1500 Gallons', '2000 Gallons'
  ],

  /* ==================================================================================
     💄 BEAUTY, COSMETICS & PERSONAL CARE
     ================================================================================== */
  'Liquid Volume (ml/oz)': [
    '5ml', '10ml', '15ml', '20ml', '30ml (1oz)', '50ml (1.7oz)', '60ml (2oz)', 
    '75ml (2.5oz)', '100ml (3.4oz)', '125ml', '150ml (5oz)', '200ml (6.7oz)', 
    '250ml (8.4oz)', '300ml', '400ml', '500ml', '750ml', '1000ml (1L)'
  ],

  'Perfume (Attar) Volume': [
    '3ml (Half Tola)', '6ml (1 Tola)', '12ml (2 Tola)', '24ml', '50ml'
  ],

  'Foundation Shades': [
    'Ivory', 'Classic Ivory', 'Porcelain', 'Natural', 'Nude', 'Beige', 
    'Warm Beige', 'Sand', 'Sun Beige', 'Golden', 'Honey', 'Caramel', 
    'Toffee', 'Tan', 'Bronze', 'Mocha', 'Cocoa', 'Espresso', 'Ebony'
  ],

  /* ==================================================================================
     🥦 GROCERY, FMCG & AGRICULTURE
     ================================================================================== */
  'Weight (Grams - Small)': [
    '5g', '10g', '15g', '20g', '25g', '30g', '40g', '50g', '60g', '70g', 
    '75g', '80g', '85g', '90g', '100g', '110g', '120g', '125g', '150g', '175g', '200g'
  ],

  'Weight (Grams - Medium)': [
    '225g', '250g (Paao)', '300g', '350g', '375g', '400g', '450g', '454g (1lb)', 
    '500g (Half Kg)', '600g', '700g', '750g', '800g', '900g', '950g'
  ],

  'Weight (Kilograms - Bulk)': [
    '1 kg', '1.5 kg', '2 kg', '2.5 kg', '3 kg', '3.5 kg', '4 kg', '4.5 kg', '5 kg', 
    '6 kg', '7 kg', '8 kg', '9 kg', '10 kg', '12 kg', '15 kg', '16 kg', '20 kg', 
    '25 kg', '30 kg', '40 kg (1 Maund)', '50 kg', '60 kg', '80 kg', '100 kg'
  ],

  'Liquid Volume (Bulk Liters)': [
    '1 Liter', '1.5 Liters', '2 Liters', '2.25 Liters', '3 Liters', '4 Liters', 
    '5 Liters', '6 Liters', '8 Liters', '10 Liters', '15 Liters', '16 Liters (Ghee Tin)', 
    '19 Liters (Water Bottle)', '20 Liters', '25 Liters', '50 Liters', '200 Liters (Drum)'
  ],

  'Diaper Sizes': [
    'Newborn (NB)', 'Size 1 (Small)', 'Size 2 (Medium)', 'Size 3 (Large)', 
    'Size 4 (Large)', 'Size 4+ (Maxi)', 'Size 5 (Junior)', 'Size 6 (XL)', 
    'Size 7 (XXL)', 'Pants M', 'Pants L', 'Pants XL', 'Pants XXL'
  ],

  /* ==================================================================================
     🏗️ HARDWARE, SOLAR & CONSTRUCTION
     ================================================================================== */
  'Solar Panel Watts': [
    '150W', '160W', '170W', '180W', '200W', '250W', '280W', '300W', '320W', 
    '350W', '380W', '400W', '440W', '450W', '480W', '530W', '535W', '540W', 
    '545W', '550W', '580W', '600W', '650W', '660W', '670W', '700W'
  ],

  'Solar Inverter Capacity': [
    '1 kW', '1.2 kW', '2.2 kW', '3 kW', '3.2 kW', '4 kW', '5 kW', '5.2 kW', 
    '6 kW', '8 kW', '10 kW', '12 kW', '15 kW', '20 kW', '25 kW', '30 kW', 
    '40 kW', '50 kW', '60 kW', '80 kW', '100 kW'
  ],

  'Electric Wire (Imperial)': [
    '3/29 (Light Duty / Bulb)', 
    '7/29 (Standard / Plug)', 
    '7/36 (Heavy)', 
    '7/44 (AC Wire Standard)', 
    '7/52 (Main Line)', 
    '7/64 (Heavy Main)', 
    '19/44', '19/52'
  ],

  'Electric Wire (mm)': [
    '1.0 mm', '1.5 mm', '2.5 mm', '4.0 mm', '6.0 mm', '10 mm', '16 mm', 
    '25 mm', '35 mm', '50 mm', '70 mm', '95 mm', '120 mm', '150 mm'
  ],

  'Steel Rod Thickness (Sutar)': [
    '2 Sutar (6mm)', '2.5 Sutar', '3 Sutar (10mm)', '4 Sutar (12mm)', 
    '5 Sutar (16mm)', '6 Sutar (20mm)', '7 Sutar (22mm)', '8 Sutar (25mm)'
  ],

  'Pipe Diameter': [
    '0.5 inch', '0.75 inch', '1 inch', '1.25 inch', '1.5 inch', '2 inch', 
    '2.5 inch', '3 inch', '4 inch', '5 inch', '6 inch', '8 inch', '10 inch', '12 inch'
  ],

  'Paint Bucket Sizes': [
    '0.91 Liters (Quarter)', '3.64 Liters (Gallon)', '14.56 Liters (Drumy)', '20 Liters (Balti)'
  ],

  /* ==================================================================================
     🚗 AUTOMOTIVE & INDUSTRIAL
     ================================================================================== */
  'Engine Oil Viscosity': [
    '0W-20', '0W-30', '0W-40', '5W-20', '5W-30', '5W-40', '5W-50', 
    '10W-30', '10W-40', '10W-50', '10W-60', '15W-40', '15W-50', 
    '20W-40', '20W-50', 'SAE 30', 'SAE 40', 'SAE 50', 'SAE 90 (Gear Oil)', 'SAE 140'
  ],

  'Engine Oil Volume': [
    '0.7 Liter (70cc)', '0.8 Liter', '1.0 Liter', '1.2 Liters', '1.5 Liters', 
    '3.0 Liters', '3.5 Liters', '3.7 Liters', '4.0 Liters', '5.0 Liters', 
    '8.0 Liters', '10 Liters', '20 Liters', '205 Liters (Drum)'
  ],

  'Tyre Rim Size': [
    'R10', 'R12', 'R13', 'R14', 'R15', 'R16', 'R17', 'R18', 'R19', 
    'R20', 'R21', 'R22', 'R23', 'R24'
  ],

  'Tyre Width': [
    '145', '155', '165', '175', '185', '195', '205', '215', '225', 
    '235', '245', '255', '265', '275', '285', '295', '305', '315', '325'
  ],

  'Helmet Sizes': [
    'XXS (51-52cm)', 'XS (53-54cm)', 'S (55-56cm)', 'M (57-58cm)', 
    'L (59-60cm)', 'XL (61-62cm)', 'XXL (63-64cm)', '3XL (65-66cm)'
  ],

  'Car Battery Model': [
    'NS40', 'NS40L', 'NS60', 'NS60L', 'N50', 'N50Z', 'N70', 'N100', 'N120', 
    'N150', 'N200', 'DIN44', 'DIN55', 'DIN66', 'DIN74', 'DIN88', 'DIN100'
  ],

  /* ==================================================================================
     🖇️ STATIONERY, OFFICE & SCHOOL
     ================================================================================== */
  'Paper Sizes': [
    'A0', 'A1', 'A2', 'A3', 'A4', 'A5', 'A6', 'A7', 'A8', 
    'B4', 'B5', 'Legal', 'Letter', 'Executive', 'Foolscap'
  ],

  'Notebook / Register Pages': [
    '40 Pages', '60 Pages', '80 Pages', '100 Pages', '120 Pages', 
    '160 Pages', '200 Pages', '240 Pages', '300 Pages', '400 Pages', '500 Pages', '1000 Pages'
  ],

  /* ==================================================================================
     💊 OPTICAL (CONTACT LENSES)
     ================================================================================== */
  'Contact Lens Power': [
    '0.00', '-0.50', '-0.75', '-1.00', '-1.25', '-1.50', '-1.75', '-2.00', 
    '-2.25', '-2.50', '-2.75', '-3.00', '-3.25', '-3.50', '-3.75', '-4.00', 
    '-4.25', '-4.50', '-4.75', '-5.00', '-5.25', '-5.50', '-5.75', '-6.00', 
    '-6.50', '-7.00', '-7.50', '-8.00', '-8.50', '-9.00', '-9.50', '-10.00', 
    '+0.50', '+1.00', '+1.50', '+2.00', '+2.50', '+3.00', '+3.50', '+4.00'
  ],

  /* ==================================================================================
     🛠️ GENERAL TOOLS & FASTENERS
     ================================================================================== */
  'Wrench / Spanner Size (mm)': [
    '6mm', '7mm', '8mm', '9mm', '10mm', '11mm', '12mm', '13mm', '14mm', 
    '15mm', '16mm', '17mm', '18mm', '19mm', '20mm', '21mm', '22mm', '24mm', 
    '27mm', '30mm', '32mm', '36mm'
  ],

  'Screw / Nail Length (Inches)': [
    '0.5"', '0.75"', '1"', '1.25"', '1.5"', '1.75"', '2"', '2.5"', '3"', 
    '3.5"', '4"', '5"', '6"'
  ],

  'Drill Bit Size (mm)': [
    '1mm', '1.5mm', '2mm', '2.5mm', '3mm', '3.5mm', '4mm', '4.5mm', '5mm', 
    '5.5mm', '6mm', '6.5mm', '7mm', '8mm', '9mm', '10mm', '11mm', '12mm', '13mm'
  ]
};